import * as React from 'react';
export const creditagricoleSvg = React.forwardRef(
  function creditagricoleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#009597',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M21.52 17.926c1.038-.525 1.68-.759 2.579-1.249l2.404 5.159h-2.836a7.14 7.14 0 0 1-.864-1.33c-.187-.514-1.027-1.961-1.284-2.58Zm-2.347-4.844-.105.117c-1.062 2.043-3.793 7.668-3.793 7.668l-3.887.969 5.836-11.672h3.887l2.474 5.626-2.918 1.54-1.494-4.248Z',
        fill: '#006A4E',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.67 11.332s-2.404 1.704-3.14 2.042c-.735.339-.933-.093-1.003-.257a13.34 13.34 0 0 1-.526-1.622c.203.022.407-.006.596-.082.467-.082 4.073-2.416 4.073-2.416',
        fill: '#ED1B2F',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm22.196 15.603-2.556 1.413a38.6 38.6 0 0 1-5.392 2.556c-2.953.887-6.548 1.435-7.832.222-1.284-1.214 1.587-5.895 6.886-7.004.864-.198.817-.104.817-.104a3.874 3.874 0 0 0-.093-2.008 1.272 1.272 0 0 0-1.366-.514c-1.167.07-6.034 1.448-7.96 5.731a5.159 5.159 0 0 0 1.354 5.708c.292.233 3.163 2.87 9.547.233a80.783 80.783 0 0 0 12.07-6.361V12.65s-2.58 1.308-5.475 2.953Z',
        fill: '#fff',
      }),
    );
  },
);
creditagricoleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var creditagricole = {
  category: 'brand',
  colorable: false,
  name: 'creditagricole',
  svg: creditagricoleSvg,
};
